export enum SegmentModeEnum {
  followAlong="followAlong", //video with notation.
  perform="perform",
  play="play", //video without notation
  practice="practice",
  time="time", //video only
  unspecified="unspecified",
}